import {FETCH_CONSIGNED_INVENTORY, FETCH_CONSIGNED_INVENTORY_ERROR} from '../actions/types';

import { handleResponseError } from './handleResponseError';

export const fetchConsignedInventory = (dataInicio, dataFim) => async (dispatch, getState, connections) => {
    const token = sessionStorage.getItem('userToken');
    connections.apiAdmin.defaults.headers['Content-Type'] = 'application/json';
    connections.apiAdmin.defaults.headers['token'] = token;

    const res  = await connections.apiAdmin
        .get(`/leituras/getByCliente/${dataInicio}/${dataFim}`, {})
        .then((res) => {
            dispatch({
                type: FETCH_CONSIGNED_INVENTORY,
                payload: res.data,
            });
        }).catch((e) => {
            dispatch({
                type: FETCH_CONSIGNED_INVENTORY_ERROR,
                payload: handleResponseError(e),
            });
        })

}